import { RoleEnum } from '@app/_api/enums/role.enum';
import { RolePermission } from '@app/shared/permission/role.permission';

export class RolePermissionBuilder {
  private readonly authorizedRoles = [] as RoleEnum[];
  static builder() {
    return new RolePermissionBuilder();
  }

  static empty() {
    return RolePermissionBuilder.builder().comparing();
  }

  authorizeRole(roleToAuthorize: RoleEnum) {
    this.authorizedRoles.push(roleToAuthorize);
    return this;
  }

  comparing(currentRole?: RoleEnum) {
    return new RolePermission(this.authorizedRoles, currentRole);
  }
}
